import { render, staticRenderFns } from "./DetailTambahProduct.vue?vue&type=template&id=5279f776&scoped=true&"
import script from "./DetailTambahProduct.vue?vue&type=script&lang=js&"
export * from "./DetailTambahProduct.vue?vue&type=script&lang=js&"
import style0 from "./DetailTambahProduct.vue?vue&type=style&index=0&id=5279f776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279f776",
  null
  
)

export default component.exports